(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-resolvia-chat-open]');
    if (!link) return;

    event.preventDefault();
    const drawer = link.closest('navigation-drawer');
    if (drawer?.open) drawer.hide();

    let attempts = 0;
    const openChat = () => {
      if (window.ResolviaChat?.open) return window.ResolviaChat.open();
      if (++attempts > 25) return (window.location.href = link.href);
      setTimeout(openChat, 200);
    };
    openChat();
  });

  } catch(e) { console.error(e); }
})();
})();
